import React from "react";
import { withFirebase } from "../../components/Firebase";

const SignOutButton = ({ firebase, handleLogout }) => {
  return (
    <span
      onClick={() => {
        handleLogout && handleLogout();
      }}
    >
      sign out
    </span>
  );
};

export default withFirebase(SignOutButton);
